<template>
  <v-card :max-width="maxWidth" class="mt-4">
    <v-form
      @submit.prevent="submitForm"
      class="ma-5"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mr-1 ml-1"
      >
        {{ alertValidate }}
      </v-alert>
      <DateWithCheck v-if="showDate" :showCheck="showCheck" class="mb-6" />

      <!-- Bloque dinámico para renderizar distintos tipos de input -->
      <template v-for="(input, i) in inputsForm">
        <!-- Renderizar SELECT -->
        <v-select
          v-if="input.type === 'select'"
          :key="'input_' + i + input.name"
          :name="input.name"
          v-model="input.data"
          :items="input.items"
          :item-text="input.itemText"
          :item-value="input.itemValue"
          :label="input.label"
          :rules="input.rules"
          :multiple="input.multiple"
          outlined
          dense
          :readonly="
            isReadonly || (isReadonly === false && input.readonly === true)
          "
        ></v-select>

        <!-- Renderizar TEXT FIELD por defecto -->
        <v-text-field
          v-else
          :key="'input_' + i + input.name"
          :name="input.name"
          v-model="input.data"
          :type="input.type"
          :label="input.label"
          :rules="input.rules"
          outlined
          dense
          :readonly="
            isReadonly || (isReadonly === false && input.readonly === true)
          "
        ></v-text-field>
      </template>

      <v-row class="justify-center">
        <div class="py-2">
          <v-btn
            :class="isReadonly ? 'bt-acept' : 'bt-exit'"
            class="ml-3"
            @click="toggleEditMode"
          >
            <v-icon>
              {{ isReadonly ? "mdi-pencil" : "mdi-close" }}
            </v-icon>
          </v-btn>
          <v-btn type="submit" class="bt-acept ml-3" v-if="!isReadonly">
            {{ $tc("editRegistrations.acept") }}
          </v-btn>
        </div>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Vue from "vue";

export default {
  components: { DateWithCheck },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    itemsSelect: Array,
    show: {
      type: Boolean,
      default: false,
    },
    itemsSlider: Array,
    showDate: Boolean,
    showCheck: {
      type: Boolean,
      default: false,
    },
    multiple: Boolean,
    itemsCheckbox: Array,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    readonly: Boolean,
  },
  data() {
    return {
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      inputSlider: [],
      checkboxes: [],
      isReadonly: false,
    };
  },
  mounted() {
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.inputSlider = Vue.observable(this.itemsSlider);
    this.isReadonly = Vue.observable(this.readonly);
  },

  methods: {
    submitForm(e) {
      this.isReadonly = !this.isReadonly;
      this.validation();
    },
    handleSubmit() {
      const itemsComplete = {};

      this.inputsForm.forEach((input) => {
        itemsComplete[input.name] = input.data;
      });

      this.$refs.form.resetValidation();

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();

      this.$emit("cancel", false);
    },
    validation() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit();
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSliderChange(slider) {
      let item = {};
      item[slider.name] = slider.data;

      this.$emit("changeSlider", item);
    },
    formatHours(value) {
      const hour = Math.floor(value / 60);
      const minutes = value % 60;
      const sign = hour >= 0 ? "" : "-";
      const formattedHour = Math.abs(hour).toString().padStart(2, "0");
      const formattedMinutes = minutes.toString().padStart(2, "0");

      return `${sign}${formattedHour}:${formattedMinutes}`;
    },
    handleChange(i) {
      console.log(i);
    },
    toggleEditMode() {
      this.isReadonly = !this.isReadonly;
    },
    generateRandomValue() {
      const randomUUID = "10000000-1000-4000-8000-100000000000".replace(
        /[018]/g,
        (c) =>
          (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16),
      );
      const lastInput = this.inputsForm[this.inputsForm.length - 1];
      if (lastInput) {
        lastInput.data = randomUUID;
      }
    },
  },
};
</script>

<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}
.slider-container {
  border: 1px solid #959595;
  margin-bottom: 30px;
  height: 110px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
